import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
export const SESSION_KEY = "ff-session";
export const TRUST_KEY = "ff-trusted";
api.interceptors.request.use((c) => {
  const s = localStorage.getItem(SESSION_KEY);
  const t = localStorage.getItem(TRUST_KEY);
  if (s) c.headers.Authorization = `Bearer ${s}`;
  if (t) c.headers["X-Trusted-Device"] = t;
  return c;
});
export const signOut = () => api.post("/auth/logout").catch(() => null).finally(() => localStorage.removeItem(SESSION_KEY));

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Request failed";
};

export const fmt = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 }));

export function usePoll(path, interval = 5000) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [lastSync, setLastSync] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const mounted = useRef(true);

  const refresh = useCallback(async () => {
    setSyncing(true);
    try {
      const r = await api.get(path);
      if (mounted.current) { setData(r.data); setError(null); setLastSync(new Date()); }
    } catch (e) {
      if (mounted.current) setError(errMsg(e));
    } finally {
      if (mounted.current) setSyncing(false);
    }
  }, [path]);

  useEffect(() => {
    mounted.current = true;
    refresh();
    const t = setInterval(() => { if (!document.hidden) refresh(); }, interval);
    return () => { mounted.current = false; clearInterval(t); };
  }, [refresh, interval]);

  return { data, error, refresh, lastSync, syncing };
}
